import { type CapitalAccountPeriodInformation, type TableColumnDisplayValues } from '../../../types';
import {CapitalAccountsTotalsChart,
  type TotalsChartItem } from '../CapitalAccountsTotalsChart';
import { formatNumber } from 'components/Pipes/numberPipes';
import { type FC } from 'react';

export const NavTotals: FC<TableColumnDisplayValues & CapitalAccountPeriodInformation> = ({
  capitalAccountReport,
  contribution,
  contributionDue,
  data,
  distribution,
  distributionWth,
  other,
  realizedGainLoss,
  unrealizedGainLoss,
}) => {
  const netGainLoss = unrealizedGainLoss + realizedGainLoss + other;
  const totalValue =
  contribution + distribution + netGainLoss + distributionWth + contributionDue;

  const { customColumns } = capitalAccountReport;

  const otherItems: TotalsChartItem[] = customColumns
    .map(({ key,
      label }) => ({
      legend: label,
      value: data[key],
    }));

  const otherTotalValue = otherItems.reduce((prev, { value }) => {
    return prev + (value || 0);
  }, 0);

  const areAllOtherValuesZero = otherItems.every(({ value }) => !value);

  const distributionItems = [
    ...distribution === 0 ? [] : [
      ...distributionWth !== 0 && distribution !== 0 ? [{
        legend: 'Distribution',
        value: distribution,
      }] : [],
      ...distributionWth === 0 ? [] : [
        {
          legend: 'Withholding tax',
          value: distributionWth,
        },
      ],
    ],
  ];

  const gainLossItems = [
    {
      legend: 'Unreal. portf. Gain/(Loss)',
      value: unrealizedGainLoss,
    },
    {
      legend: 'Real. portf. Gain/(Loss)',
      value: realizedGainLoss,
    },
  ];

  return <div className='flex w-full flex-col gap-[0.75rem] rounded-medium bg-white-999 p-[1rem] shadow-card-x3 ms:p-[1.25rem]'>
    <div className='flex justify-between border-b border-black-200 pb-[0.75rem]'>
      <div className=' text-font-1 font-medium ms:text-title-4'>Partners capital (NAV)</div>
      <div className='text-title-3 font-semibold'>{formatNumber(totalValue, 0, true)}</div>
    </div>
    <CapitalAccountsTotalsChart
      title='Contribution (Net due/advance)'
      totalValue={contribution + contributionDue}
    />
    <CapitalAccountsTotalsChart
      items={distributionItems}
      title='Distribution'
      totalValue={distribution + distributionWth}
    />
    <CapitalAccountsTotalsChart
      items={gainLossItems}
      title='Portfolio Gain / (Loss)'
      totalValue={netGainLoss}
    />
    {areAllOtherValuesZero ? null : <CapitalAccountsTotalsChart
      items={otherItems}
      title='Operating Expenses'
      totalValue={otherTotalValue}
    />}
  </div>;
};
